module.exports = __webpack_public_path__ + "img/reply.c0d82336.svg";